import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-prime-dropdown',
  templateUrl: './prime-dropdown.component.html',
  styleUrls: ['./prime-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrimeDropdownComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PrimeDropdownComponent implements ControlValueAccessor, OnChanges, OnInit {
  @Input() options: any[];
  @Input() optionLabel: any;
  @Input() defaultOptionLabel: any;
  @Input() dataKey: string;
  @Input() outputValue: any;
  @Input() selectedItem: any;
  @Input() required: boolean;
  @Input() inputId: string;
  @Input() abortPlaceholderInitialization: boolean = false;
  @Input() styleClass: string = '';
  @Input() filter: boolean = false;
  @Input() emptyFilterMessage: string = 'Результаты не найдены';
  @Input() selectId: string = null;
  @Input() showClear: boolean = false;
  @Input() returnFullOptionObject: boolean = false;
  @Input() autoDisplayFirst: boolean = true;
  @Input() placeholderText: string = 'Выбрать';
  @Input() disabled: boolean = false;

  @Output() valueChange = new EventEmitter();
  @Output() onHideEvent = new EventEmitter();
  @Output() onClearEvent = new EventEmitter();
  @Output() fullOptionObjectValueChange = new EventEmitter();
  public choose = 'Выберите';
  private placeholder = null;
  private currentValue = null;

  constructor() {}

  ngOnInit() {
    this.dataKey = this.dataKey || 'Id';
    this.optionLabel = this.optionLabel || 'Title';
    if (!this.abortPlaceholderInitialization) {
      this.initPlaceholder();
      const isOptionLabelEqualToChoose = this.options.some(
        (option) => option[this.optionLabel] === this.choose
      );
      if (!isOptionLabelEqualToChoose) {
        this.options.unshift(this.placeholder);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options) {
      if (this.selectedItem) {
        this.currentValue = this.selectedItem;
      }
      if (this.currentValue) {
        this.restoreSelectedItem();
      }
      if (
        this.placeholder &&
        this.options.indexOf(this.placeholder) === -1 &&
        !this.abortPlaceholderInitialization
      ) {
        this.options.unshift(this.placeholder);
      }
    }
  }

  onChange: any = () => {};
  onToched: any = () => {};

  writeValue(value: any): void {
    this.currentValue = value;
    this.restoreSelectedItem();
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onToched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /** Обработчик изменения значения в списке */
  selectionChange($event: any) {
    this.outputValue = null;
    if ($event.value) {
      this.outputValue = this.selectedItem[this.dataKey];
      if (this.returnFullOptionObject) {
        this.fullOptionObjectValueChange.emit(this.selectedItem);
      }
    }
    this.valueChange.emit(this.outputValue);
    this.writeValue(this.outputValue);
  }
  onHide() {
    this.onHideEvent.emit();
  }

  onClear() {
    this.selectedItem = null;
    this.valueChange.emit(this.selectedItem);
    this.writeValue(this.selectedItem);
    this.onClearEvent.emit();
  }
  /** Инициализирует пустое значение в списке */
  private initPlaceholder() {
    this.placeholder = {};
    this.placeholder[this.dataKey] = null;
    this.placeholder[this.optionLabel] = this.defaultOptionLabel || this.choose;
  }

  /** Восстанавливает сохраненное значение как выбранное в списке */
  private restoreSelectedItem() {
    if (
      this.currentValue &&
      this.currentValue.hasOwnProperty(this.dataKey || 'Id') &&
      this.currentValue.hasOwnProperty(this.optionLabel || 'Title')
    ) {
      this.selectedItem = this.options.find(
        (o) => o[this.dataKey || 'Id'] === this.currentValue[this.dataKey || 'Id']
      );
    } else {
      this.selectedItem = this.options.find((o) => o[this.dataKey || 'Id'] === this.currentValue);
    }
  }
}
